import { useMutation } from 'react-query';
import { duplicateDemand } from 'src/services/api/demands';

function useDuplicateDemand() {
  return useMutation(({ demandId, doctorId, all }) => duplicateDemand(demandId, { doctorId }, all));
}

export default useDuplicateDemand;
